import { render, staticRenderFns } from "./UsuarioInfo.vue?vue&type=template&id=7a8e5b72&"
import script from "./UsuarioInfo.vue?vue&type=script&lang=js&"
export * from "./UsuarioInfo.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports